<template>
  <div>
    <TopMenu :leftOption="'back-dashboard'" :title="$t('Jingle Schedule')" />
    <div class="view">
      <transition name="fade" appear>
        <ScheduleLayout
          :schedules="schedules"
          :loading="loadingSchedules"
          :deletingSchedules="deletingSchedules"
          :editRoute="ROUTE_JINGLE_SCHEDULE_EDIT"
          :addRoute="ROUTE_JINGLE_SCHEDULE_ADD"
          :addButtonText="$t('Add Jingle Block')"
          @edit="editSchedule"
          @delete="deleteSchedule"
          @create="createSchedule"
        >
          <template #mobile-item="{ schedule }">
            <div>
              <span class="text-white h3 font-weight-light">{{schedule.start_time.substr(0,5)}} - {{schedule.end_time.substr(0,5)}}</span><br>
              <small class="text-muted">{{ schedule.jingles.map(jingle => jingle.title).join(', ') }}</small>
            </div>
          </template>
          <template #desktop-item="{ schedule }">
            <div class="week-schedule-info">
              <span class="text-white font-weight-light">{{schedule.start_time.substr(0,5)}} - {{schedule.end_time.substr(0,5)}}</span><br>
              <small class="text-muted week-schedule-name">{{ schedule.jingles.map(jingle => jingle.title).join(', ') }}</small>
            </div>
          </template>
        </ScheduleLayout>
      </transition>
    </div>
  </div>
</template>

<script>
import musicboxClient from '@/utils/musicboxClient'
import { ROUTE_JINGLE_SCHEDULE_EDIT, ROUTE_JINGLE_SCHEDULE_ADD } from '@/const/routeNames'
import ScheduleLayout from '@/components/shared/ScheduleLayout'

export default {

  name: 'JingleSchedule',

  components: {
    ScheduleLayout
  },

  created () {
    this.loadingSchedules = true
    musicboxClient
      .getJingleSchedules(this.$store.state.audio.currentBox.uuid)
      .then(res => {
        this.schedules = res.data != null ? res.data : []
      })
      .catch(e => {
        this.$notify.danger(this.$t('Failed to load schedules'))
      })
      .then(() => { this.loadingSchedules = false })
  },

  data () {
    return {
      ROUTE_JINGLE_SCHEDULE_EDIT,
      ROUTE_JINGLE_SCHEDULE_ADD,
      loadingSchedules: false,
      deletingSchedules: new Set(),
      schedules: []
    }
  },

  methods: {
    deleteSchedule (schedule) {
      if (this.deletingSchedules.has(schedule.id)) { return }
      this.deletingSchedules.add(schedule.id)
      this.deletingSchedules = new Set(this.deletingSchedules)
      musicboxClient
        .deleteJingleSchedule(this.$store.state.audio.currentBox.uuid, schedule.id)
        .then(res => {
          this.$notify.success(this.$t('Schedule deleted'))
          this.schedules = this.schedules.filter(s => s.id !== schedule.id)
        })
        .catch(e => { this.$notify.danger(this.$t('Failed to delete schedule')) })
        .then(() => {
          this.deletingSchedules.delete(schedule.id)
          this.deletingSchedules = new Set(this.deletingSchedules)
        })
    },
    editSchedule (schedule) {
      this.$store.commit('clearEditedJingleSchedule')
      this.$router.push(ROUTE_JINGLE_SCHEDULE_EDIT.replace(':id', schedule.id))
    },
    createSchedule (selectedDayOfWeek) {
      this.$store.commit('initEditedJingleSchedule')
      const preselect = new Set()
      preselect.add(selectedDayOfWeek)
      this.$store.commit('updateEditedJingleSchedule', { key: 'selectedDaysOfWeek', value: preselect })
      this.$router.push(ROUTE_JINGLE_SCHEDULE_ADD)
    }
  }
}

</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/JingleSchedule.vue